import {
  BAG_FRONT_POCKET,
  BAG_CENTRAL_POCKET,
  BAG_BACK_POCKET,
} from "./bagChecklistFields";

function bools<T extends ReadonlyArray<readonly [string, string, string]>>(
  items: T
) {
  return Object.fromEntries(items.map((t) => [t[0], false])) as {
    [K in T[number][0]]: boolean;
  };
}

export function buildInitialBagChecklist() {
  return {
    hospitalId: "",
    date: new Date().toISOString().slice(0, 10),
    shift: "D" as "D" | "N",
    checkedByName: "",
    checkedByBadge: "",
    frontPocket: bools(BAG_FRONT_POCKET),
    centralPocket: bools(BAG_CENTRAL_POCKET),
    backPocket: bools(BAG_BACK_POCKET),
  };
}

export type BagChecklistFormState = ReturnType<typeof buildInitialBagChecklist>;
